import React from "react";
import Header from "../../../components/Header/Header";
import {
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
} from "@mui/material";
import "./preMapData.scss";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/pre_processor/actions";
import { connect } from "react-redux";
import "react-multi-carousel/lib/styles.css";
import IconButton from "@mui/material/IconButton";
import MapDataContainer from "./MapDataContainer";
import styled from "styled-components";
import HideImageOutlinedIcon from "@mui/icons-material/HideImageOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";

const ColorlibConnector = styled(StepConnector)({
  alternativeLabel: {},
  active: {
    "& $line": {
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      fontWeight: 700,
    },
  },
  completed: {
    "& $line": {
      borderColor: "rgba(0,0,0,0.7)",
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      borderTopWidth: "0px!important",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#B9B9B9",
    borderRadius: 1,
    borderTopWidth: "0px!important",
  },
});

class MapData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // loader: false,
      // sucessNotification: false,
      // errorNotification: false,
      // message: "",
      // isFullView: false,
      leftgrid: 6,
      rightgrid: 6,
      isFullScreen: true,
      hideScreen: true,
      action: "",
      projectType: localStorage.getItem("projectType") || "",
    };
    // Create the child instance using react createRef
    // this.child = React.createRef();
    // this.qcChild = React.createRef();
  }

  componentDidMount() {
    this.props.acts.clearApiStatus();
    this.props.acts.getCoorData(localStorage.projectId);
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (nextProps?.apiStatus.loader === true) {
  //     this.setState({
  //       loader: true,
  //     });
  //   }
  //   if (
  //     nextProps?.apiStatus.loader === false &&
  //     nextProps?.apiStatus.next === false &&
  //     nextProps?.apiStatus.apiSuccess === true
  //   ) {
  //     this.setState({
  //       sucessNotification: true,
  //       message: notification.successMessage,
  //     });
  //   }
  //   if (
  //     nextProps?.apiStatus.loader === false &&
  //     // nextProps?.apiStatus.next === true &&
  //     nextProps?.apiStatus.apiSuccess === true
  //   ) {
  //     // if (this.state.action === "save") {
  //     if (nextProps?.apiStatus.next === false) {
  //       this.setState({
  //         loader: false,
  //         sucessNotification: true,
  //         errorNotification: false,
  //         message: notification.successMessage,
  //       });
  //     }
  //     if (nextProps?.apiStatus.next === true) {
  //       // if (this.state.action === "saveAndNext") {
  //       this.setState({
  //         loader: false,
  //         sucessNotification: true,
  //         errorNotification: false,
  //         message: notification.successMessage,
  //       });
  //       setTimeout(() => {
  //         this.setState({
  //           sucessNotification: false,
  //           message: "",
  //         });
  //         this.props.navigate("/pre-processor-dashboard");
  //       }, 2000);
  //     }
  //   }
  //   if (
  //     nextProps?.apiStatus.loader === false &&
  //     nextProps?.apiStatus?.apiError === true
  //   ) {
  //     this.setState({
  //       loader: false,
  //       sucessNotification: false,
  //       errorNotification: true,
  //       message: nextProps?.apiStatus.message,
  //     });
  //   }
  // }

  // onClickFooterAction = (action) => {
  //   this.setState({
  //     action: action,
  //   });

  //   if (action === "cancel") {
  //     this.props.navigate("/pre-processor-dashboard");
  //   } else if (action === "previous") {
  //     this.props.navigate("/upload-template-data");
  //   } // Check if `this.child` exists and call its method
  //   else if (this.child.current) {
  //     this.child.current.mapData(action);
  //   } else {
  //     console.error("child is null or not yet rendered");
  //   }

  //   // Check if `this.qcChild` exists and call its method
  //   // if (this.qcChild.current) {
  //   //   this.qcChild.current.mapData2(action);
  //   // } else {
  //   //   console.error("qcChild is null or not yet rendered");
  //   // }
  // };

  // handleCloseFullView = () => {
  //   this.setState({ isFullView: false });
  // };

  // handleOpenFullView = () => {
  //   this.setState({ isFullView: true });
  // };

  slideScreentoMaximize = () => {
    this.setState({ rightgrid: 12 });
    this.setState({ isFullScreen: false });
    this.setState({ hideScreen: false });
  };
  slideScreentoMinimize = () => {
    this.setState({ leftgrid: 6 });
    this.setState({ rightgrid: 6 });
    this.setState({ isFullScreen: true });
    this.setState({ hideScreen: true });
  };

  render() {
    return (
      <div>
        <Header />

        <div className="premap-data-container">
          {this.state.isFullScreen ? (
            <div
            // className="slide-button"
            >
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => this.slideScreentoMaximize()}
              >
                <ImageOutlinedIcon />
              </IconButton>

              {/* <Buttons
                size="small"
                onClick={() => this.slideScreentoMaximize()}
                // text="Hide PDF"
                startIcon={<HideImageTwoToneIcon />}
                variant="outlined"
              /> */}
            </div>
          ) : (
            <div
            // className="slide-button"
            >
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => this.slideScreentoMinimize()}
              >
                <HideImageOutlinedIcon />
              </IconButton>

              {/* <Buttons
                size="small"
                onClick={() => this.slideScreentoMinimize()}
                // text="Show PDF"
                startIcon={<HideImageTwoToneIcon />}
                variant="outlined"
              /> */}
            </div>
          )}

          <Typography className="project-batch-header">
            {localStorage.projectName + " - " + localStorage.drugType}
          </Typography>

          {/* <Box className="stepper-wrap"> */}
          <Stepper
            activeStep={this.state.activeStep}
            connector={<ColorlibConnector />}
          >
            <Step key="Map Data" className="stepper-wrap-label">
              <StepLabel>Map Data</StepLabel>
            </Step>
          </Stepper>
          {/* </Box> */}

          {/* <IconButton aria-label="fullView">
            <Typography className="current-step">Map Data</Typography>
          </IconButton> */}
        </div>

        {/* {this?.state?.isFullView ? (
          <Dialog
            fullScreen={true}
            open={this?.state?.isFullView}
            aria-labelledby="responsive-dialog-title"
            keepMounted={true}
          >
            <DialogActions className="dialog-style">
              {this.state.isFullScreen ? (
                <div className="slide-button">
                  <Buttons
                    size="medium"
                    onClick={() => this.slideScreentoMaximize()}
                    text="Hide PDF"
                    startIcon={<ArrowLeftIcon />}
                  />
                </div>
              ) : (
                <div className="slide-button">
                  <Buttons
                    size="small"
                    onClick={() => this.slideScreentoMinimize()}
                    text="Show PDF"
                    startIcon={<ArrowRightIcon />}
                  />
                </div>
              )}
              <Typography>
                {localStorage.projectName + "-" + localStorage.drugType}
              </Typography>

              <IconButton
                className="fullview-close"
                aria-label="close"
                onClick={this.handleCloseFullView}
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>

            <DialogContent className="fullscreen-table-wrap">
              <MapDataContainer
                child={this.child}
                isFullView={this?.state?.isFullView}
                hideScreen={this?.state?.hideScreen}
                leftgrid={this?.state?.leftgrid}
                rightgrid={this?.state?.rightgrid}
              />
            </DialogContent>
          </Dialog>
        ) : ( */}
        <MapDataContainer
          hideScreen={this?.state?.hideScreen}
          leftgrid={this?.state?.leftgrid}
          rightgrid={this?.state?.rightgrid}
          // child={this.child}
          navigate={this?.props?.navigate}
          // qcChild={this.qcChild}

          // isFullView={this?.state?.isFullView}
        />
        {/* )} */}

        {/* <MapFooter
          pdfCount={this.props?.coorData.length}
          isDisableMultipageMappingLable={true}
          onClickFooterAction={this.onClickFooterAction}
          isShowReject={false}
          isPrevious={true}
          // disableSaveAndNext={
            // this.state.extractionCheckBoxTypes?.template_driven === true &&
            // this.state.extractionCheckBoxTypes?.free_form === true && 
          // }
        /> */}
        {/* {this.state?.sucessNotification && (
          <CustomizedSnackbar
            severity="success"
            state={this.state?.sucessNotification}
            text={this.state?.message}
            handleClose={() =>
              this.setState({
                sucessNotification: false,
              })
            }
          />
        )}
        {this.state?.errorNotification && (
          <CustomizedSnackbar
            severity="error"
            state={this.state?.errorNotification}
            text={this.state.message}
            handleClose={() =>
              this.setState({
                errorNotification: false,
              })
            }
          />
        )} */}

        {/* {this?.props?.apiStatus.loader ? <ProgressBar /> : ""} */}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    coorData: state.prePro?.coorData?.coordinatesDetails || [],
    // apiStatus: state.prePro?.apiStatus,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapData);
